export const FETCH_ADMIN_JOB_BEGIN = 'syftacp/FETCH_ADMIN_JOB_BEGIN' as const
export const FETCH_ADMIN_JOB_FAILED = 'syftacp/FETCH_ADMIN_JOB_FAILED' as const
export const FETCH_ADMIN_JOB_SUCCEEDED = 'syftacp/FETCH_ADMIN_JOB_SUCCEEDED' as const

export const JOB_RATE_WORKER_BEGIN = 'syftacp/JOB_RATE_WORKER_BEGIN' as const
export const JOB_RATE_WORKER_FAILED = 'syftacp/JOB_RATE_WORKER_FAILED' as const
export const JOB_RATE_WORKER_SUCCEEDED = 'syftacp/JOB_RATE_WORKER_SUCCEEDED' as const

export const JOB_UPDATE_BEGIN = 'syftacp/JOB_UPDATE_BEGIN' as const
export const JOB_UPDATE_FAILED = 'syftacp/JOB_UPDATE_FAILED' as const
export const JOB_UPDATE_SUCCEEDED = 'syftacp/JOB_UPDATE_SUCCEEDED' as const

export const JOB_STOP_OFFERS_UPDATE_BY_SHIFT = 'syftacp/JOB_STOP_OFFERS_UPDATE_BY_SHIFT' as const

export const RATING_DELETE_BEGIN = 'syftacp/RATING_DELETE_BEGIN' as const
export const RATING_DELETE_FAILED = 'syftacp/RATING_DELETE_FAILED' as const
export const RATING_DELETE_SUCCEEDED = 'syftacp/RATING_DELETE_SUCCEEDED' as const

export const JOB_EXTEND_LTA_BEGIN = 'syftacp/JOB_EXTEND_LTA_BEGIN' as const
export const JOB_EXTEND_LTA_FAILED = 'syftacp/JOB_EXTEND_LTA_FAILED' as const
export const JOB_EXTEND_LTA_SUCCEEDED = 'syftacp/JOB_EXTEND_LTA_SUCCEEDED' as const

export const JOB_FETCH_LTA_EXTENSIONS_BEGIN = 'syftacp/JOB_FETCH_LTA_EXTENSIONS_BEGIN' as const
export const JOB_FETCH_LTA_EXTENSIONS_FAILED = 'syftacp/JOB_FETCH_LTA_EXTENSIONS_FAILED' as const
export const JOB_FETCH_LTA_EXTENSIONS_SUCCEEDED = 'syftacp/JOB_FETCH_LTA_EXTENSIONS_SUCCEEDED' as const

export const JOB_CANCEL_LTA_EXTENSION_BEGIN = 'syftacp/JOB_CANCEL_LTA_EXTENSION_BEGIN' as const
export const JOB_CANCEL_LTA_EXTENSION_FAILED = 'syftacp/JOB_CANCEL_LTA_EXTENSION_FAILED' as const
export const JOB_CANCEL_LTA_EXTENSION_SUCCEEDED = 'syftacp/JOB_CANCEL_LTA_EXTENSION_SUCCEEDED' as const

export const JOB_EXTEND_BOOKING_BEGIN = 'syftacp/JOB_EXTEND_BOOKING_BEGIN' as const
export const JOB_EXTEND_BOOKING_FAILED = 'syftacp/JOB_EXTEND_BOOKING_FAILED' as const
export const JOB_EXTEND_BOOKING_SUCCEEDED = 'syftacp/JOB_EXTEND_BOOKING_SUCCEEDED' as const

export const JOB_EXTEND_AGENCY_BOOKING_BEGIN = 'syftacp/JOB_EXTEND_AGENCY_BOOKING_BEGIN' as const
export const JOB_EXTEND_AGENCY_BOOKING_FAILED = 'syftacp/JOB_EXTEND_AGENCY_BOOKING_FAILED' as const
export const JOB_EXTEND_AGENCY_BOOKING_SUCCEEDED = 'syftacp/JOB_EXTEND_AGENCY_BOOKING_SUCCEEDED' as const
